import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormControl, FormArray, Validators, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { filter } from 'rxjs/operators';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import {
   RelativeDateService,
   TimePeriods, TimePeriodsMap,
   RelativeTokens,
} from '@library/common/datehandler';

import { DateTokens } from '../rdate';

const OperandGroup = ( group?: any ) => new FormGroup({
   operation: new FormControl( group?.operation ?? '+', [ Validators.required ]),
   amount: new FormControl( group?.amount ?? 1, [
      Validators.required,
      Validators.min( 1 ),
      Validators.max( 999 ),
      Validators.pattern( /^-?[0-9][^\.]*$/ ),
   ]),
   period: new FormControl( group?.period ?? TimePeriods[0], [ Validators.required ]),
   token: new FormControl( group?.token ?? RelativeTokens.Week_Start, [ Validators.required ]),
});

@UntilDestroy()
@Component({
   selector: 'lib-rdate-filter',
   templateUrl: './rdate-filter.component.html',
   styleUrls: ['./rdate-filter.component.scss'],
   inputs: [ 'placeholder', 'formControl' ],
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         useExisting: forwardRef(() => RdateFilterComponent ),
         multi: true,
      },
   ],
})
export class RdateFilterComponent implements OnInit, ControlValueAccessor {

   placeholder: string = 'Date';
   formControl:FormControl = new FormControl( 'T' );

   get datestring() { return this.formControl.value; }

   get today() { return new Date(); }

   DateTokens = DateTokens;
   RelativeTokens = RelativeTokens;
   TimePeriods = TimePeriods;
   TimePeriodsMap = TimePeriodsMap;

   dateTokens: string[] = Object.keys( DateTokens );
   relativeTokens: string[] = Object.keys( RelativeTokens );

   maths: FormGroup = new FormGroup({
      start: new FormControl( DateTokens[this.dateTokens[0]]),
      operands: new FormArray([]),
   });

   get start() { return this.maths.get( 'start' ); }
   get operands() { return this.maths.get( 'operands' ) as FormArray; }

   onChange = ( _: any ) => {};
   onTouched = ( _: any ) => {};

   constructor(
      public rdate: RelativeDateService,
   ) { }

   ngOnInit() {
      if ( !this.datestring ) { setTimeout( _ => this.formControl.setValue( 'T' )); }

      const parsed = this.rdate.parseString( this.datestring, DateTokens );
      if ( parsed ) {
         this.start.setValue( parsed.start );
         parsed?.operands.map( o => this.operands.push( OperandGroup( o )));
      }

   }

   addOperand() {
      this.operands.push( OperandGroup() );
   }

   removeOperand( index: number ) {
      this.operands.removeAt( index );
   }

   getDate( operandsIndex: number ) {
      if ( operandsIndex < 0 || !this.maths.valid ) { return this.rdate.getDate( this.maths.value.start ); }

      const maths = this.maths.value;

      return this.rdate.getDate({
         start: maths.start,
         operands: maths.operands.slice( 0, ++operandsIndex ),
      });
   }

   writeValue( _: any ) {
      this.maths.valueChanges.pipe(
         filter( _ => !!this.maths.valid ),
         untilDestroyed( this ),
      ).subscribe( _ => this.formControl.setValue( this.rdate.makeString( this.maths.value )));
   }

   registerOnChange( fn: ( _: any ) => void ) {
      this.onChange = fn;
   }

   registerOnTouched( fn: ( _: any ) => void ) {
      this.onTouched = fn;
   }

}
